import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { UpdateAdditionalInformationMutationRequest, UpdateAdditionalInformationMutationResponse, UpdateAdditionalInformation400, UpdateAdditionalInformation500 } from "../types/UpdateAdditionalInformation";

/**
 * @summary Обновить дополнительную информацию для организации
 * @link /api/lk/organization/additional-info
 */

export function useUpdateAdditionalInformation <TData = UpdateAdditionalInformationMutationResponse, TError = UpdateAdditionalInformation400 | UpdateAdditionalInformation500, TVariables = UpdateAdditionalInformationMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "patch",
        url: `/api/lk/organization/additional-info`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
